<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>
    <!-- banner图 -->
    <div id="banner">
      <el-carousel :interval="5000" :height="bannerHeight + 'px'">
        <el-carousel-item class="ban">
          <img style="" src="~@/common/imgs/banner-2020-10-13.png" object-fit='fill'>
        </el-carousel-item>
        <el-carousel-item class="ban">
          <img style="" src="~@/common/imgs/banner-2020-08-18.png" object-fit='fill'>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- news -->
    <div id="news">
      <div class="new-content">
        <div class="new-title">
          公司新闻
        </div>
          <el-divider></el-divider>
        <div class="new-body">
          <div class="new-list">
            <router-link :to="{path:'/Detail',query:{id:news.id,total: total}}" v-for="news in newslist" :key="news.id">
              <span>{{news.createTime | subTime}}</span>丨
              <p>{{news.title}}</p>
              <img src="~@/common/imgs/new.png" alt="" v-if="isShow(news.sendTime)">
            </router-link>
          </div>
        </div>
        <div class="new-more">
          <router-link to="/Articles" class="more">MORE<i class="el-icon-d-arrow-right"></i></router-link>
        </div>
      </div>
    </div>

    <!-- footer -->
    <foot-link></foot-link>

    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import axios from 'axios'
  import global_msg from '@/common/js/global.js'
  import {
    mapState,
    mapMutations,
    mapActions
  } from 'vuex'

  export default {
    name: 'Index',
    data() {
      return {
        input: '',
        currentPage: 1, //当前页数
        bannerHeight: 600, //图片父容器高度
        screenWidth: 0 // 浏览器宽度
      }
    },
    created() {
      this.$store.dispatch('getData', this.currentPage);
    },
    mounted() {
      this.setSize();
      // 窗口大小发生改变时,调用一次
      window.onresize = () => {
        this.setSize();
      }
    },
    computed: {
      ...mapState(['newslist', 'total'])
    },
    methods: {
      isShow(time) {
        if(time){
          time = time.substr(0,10);
          var nowDate = new Date(); //结束时间
          var date = nowDate.getTime() - new Date(time).getTime(); //时间差的毫秒数
          //计算出相差天数
          var days = Math.floor(date / (24 * 3600 * 1000));
          if (days > 5) {
            return false
          } else {
            return true
          }
        }else{
          return ""
        }

      },
      setSize: function() {
        // 首次加载时,需要调用一次
        this.screenWidth = window.innerWidth;
        // 通过浏览器宽度(图片宽度)计算高度
        this.bannerHeight = 600 / 1920 * this.screenWidth;
      },
    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    },
    filters: {
      subTime: function(str) {
        return str.substr(0, 10)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Index.vue